import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { OrderProcessingType } from "../../../../../shared/types/OrderProcessingType";

type Props = {
    value: OrderProcessingType;
    disabled: boolean;
    automaticRatesAvailable: boolean;
    onValueChange: (value: OrderProcessingType) => void;
};

export function OrderProcessingTypeSelector({
    value,
    disabled,
    automaticRatesAvailable,
    onValueChange,
}: Props) {
    return (
        <FormControl variant="standard" sx={{ width: 130 }} disabled={disabled}>
            <InputLabel id="order-processing-type-label">Fee mode</InputLabel>
            <Select
                labelId="order-processing-type-label"
                id="orderProcessingType"
                size="small"
                value={OrderProcessingType[value]}
                onChange={(event: SelectChangeEvent<string>) =>
                    onValueChange(OrderProcessingType[event.target.value as keyof typeof OrderProcessingType])}
                sx={{
                    "& .MuiInputBase-input": {
                        paddingBottom: '2px',
                    },
                }}
            >
                <MenuItem value="Manual">Manual</MenuItem>
                <MenuItem value="Taker" disabled={!automaticRatesAvailable}>Auto: Taker</MenuItem>
                <MenuItem value="Maker" disabled={!automaticRatesAvailable}>Auto: Maker</MenuItem>
            </Select>
        </FormControl>
    );
}
